export const defaultState = {
  operators: [],
  currentOperator: {},
  sponsors: [],
  verticals: [],
  cities: [],
};

export default function info(state = defaultState, action) {
  switch (action.type) {
    case 'SET_ALL_OPERATORS':
      // return Object.assign({}, state, action.payload.operators);
      return {
        ...state,
        operators: action.payload.operators,
        currentOperator: action.payload.currentOperator,
        sponsors: action.payload.sponsors,
        verticals: action.payload.verticals,
        userDetails: action.payload.userDetails,
        cities: action.payload.cities,
      };

    default:
      return state;
  }
}
